import React, { Fragment } from 'react';
import styles from './styles.module.scss';
import Card from '@components/Card';
import { Col, Divider, Row } from '@components/Grid';
import { Link } from '@reach/router';
import Img from 'gatsby-image';
import { getProductDiscountPrice, getPublicProductDiscount } from '@helpers/store';
import Button from '@components/Button';
import { graphql, useStaticQuery } from 'gatsby';
import { useDispatch, useSelector } from 'react-redux';
import { setBasketItem } from '@actions/basket';
import { makePostRequest, makePutRequest } from '@helpers/requests';
import { BASKET_ADD, BASKET_CREATE } from '@helpers/api';
// import ReactPixel from 'react-facebook-pixel';
import { useSnackbar } from '@components/Snackbar';

const ProductCard = ({ product, basket, addToBasket = false }) => {
    const [openSnackbar] = useSnackbar();
    const dispatch = useDispatch();
    const basketId = useSelector(({ basket }) => basket?.id);
    const { _id: id, shortName, name, price, images, description } = product;
    const discount = getPublicProductDiscount({
        price: product?.price,
        discounts: product?.discounts,
    });

    const {
        merlinWebsite: {
            store: {
                currency: { symbol: currencySymbol, code: currencyCode },
            },
        },
    } = useStaticQuery(graphql`
        query {
            merlinWebsite {
                store {
                    currency {
                        symbol
                        code
                    }
                }
            }
        }
    `);


    const handleAddToBasket = async () => {
        try {
            const quantity = ((basket.find(item => item.id === id) || {}).quantity || 0) + 1;

            dispatch(setBasketItem({ id, quantity }));

            if (!!basketId) {
                const { data: basketData } = await makePutRequest(BASKET_ADD(basketId), {
                    productId: id,
                    quantity: ((basket.find(item => item.id === id) || {}).quantity || 0) + 1,
                });

                const newQuantity =
                    basketData?.products?.find(({ productId }) => productId === id)?.quantity ??
                    quantity;

                if (quantity !== newQuantity) {
                    dispatch(setBasketItem({ id, quantity: newQuantity }));
                }

                // if (process.env.NODE_ENV === 'production') {
                //     ReactPixel.track('AddToCart', {
                //         content_type: 'product',
                //         content_name: name,
                //         content_ids: [id],
                //         currency: currencyCode,
                //         value: parseFloat(price / 100),
                //     });
                // }

                openSnackbar(`You successfully added ${name} to your basket.`);
            } else {
                const { data: basketData } = await makePostRequest(BASKET_CREATE, {
                    productId: id,
                    quantity: 1,
                });

                const newQuantity =
                    basketData?.products?.find(({ productId }) => productId === id)?.quantity ??
                    quantity;

                dispatch(setBasketItem({ id, quantity: newQuantity, basketId: basketData?._id }));

                // if (process.env.NODE_ENV === 'production') {
                //     ReactPixel.track('AddToCart', {
                //         content_type: 'product',
                //         content_ids: [id],
                //         content_name: name,
                //         currency: currencyCode,
                //         value: parseFloat(price / 100),
                //     });
                // }

                openSnackbar(`You successfully added ${name} to your basket.`);
            }
        } catch (error) {
            error !== 'cancelled' &&
                openSnackbar(
                    error?.errorMessage ??
                        'An error occurred when attempting to add this product to your basket.'
                );
        }
    };

    return (
        <Link
            className={styles.product}
            style={{
                textDecoration: 'none',
                color: 'black',
                display: 'block',
                width: '100%',
            }}
            to={`/product/${product.shortName}`}
        >
            <Img
                sizes={{
                    ...product.images[0].image.childImageSharp.fluid,
                    aspectRatio: 4 / 3,
                }}
            />
            <div className={styles.productContent}>
                <p> {product.name}</p>
                <Divider margin={1} />
                <div
                    className={`${styles.productPrice} ${
                        !!discount ? styles.productPriceDiscounted : ''
                    }`}
                >
                    {!!discount && (
                        <span className={styles.productPriceDiscount}>
                            {`${currencySymbol}${parseFloat(
                                getProductDiscountPrice({
                                    price: product?.price,
                                    discount,
                                }) / 100
                            ).toFixed(2)}`}
                        </span>
                    )}
                    <span className={styles.productPriceRetail}>
                        {`${currencySymbol}${parseFloat(product.price / 100).toFixed(2)}`}
                    </span>
                </div>

                {addToBasket && (
                    <Fragment>
                        <Divider margin={2} />
                        <Row center="xs" middle="xs">
                            <Col>
                                <Button
                                    text="Add To Cart"
                                    onClick={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        handleAddToBasket();
                                    }}
                                />
                            </Col>
                        </Row>
                    </Fragment>
                )}
            </div>
        </Link>
    );
};

export default ProductCard;
